export default __webpack_public_path__ + "static/media/camera.04e099e9.png";